// List of traffic signs: https://github.com/tomtom-internal/fcd-trace/blob/edi-develop/trace-fcd/src/main/java/com/tomtom/trace/fcd/event/TrafficSign.java
// List of traffic sign icons: https://github.com/tomtom-internal/fcd-trace/tree/edi-develop/trace-render/src/main/resources/public/tomtom/icons/signs
// ! Change this array to set the default TrafficSigns to fetch from the API.
export var UNUSED_SIGN_TYPES = [
  "SPEED_LIMIT",
  "SPEED_LIMIT_END",
  "SPEED_LIMIT_CHANGE_UPCOMING",
  "NO_OVERTAKING",
  "NO_OVERTAKING_END",
  "NO_OVERTAKING_TRUCK",
  "NO_OVERTAKING_TRUCK_END",
  "ALL_RESTRICTIONS_END",
  "CITY_START",
  "CITY_END",
  "HIGHWAY",
  "HIGHWAY_END",
  "MOTORWAY",
  "MOTORWAY_END",
  "CONSTRUCTION",
  "CONSTRUCTION_END",
  "LANE_MERGE_ON_RIGHT",
  "LANE_MERGE_ON_LEFT",
  "RAILWAY_CROSSING_GENERAL",
  "RAILWAY_CROSSING_PROTECTED",
  "RAILWAY_CROSSING_UNPROTECTED",
  "ROAD_NARROWS",
  "ROAD_NARROWS_LEFT",
  "ROAD_NARROWS_RIGHT",
  "SHARP_CURVE_LEFT",
  "SHARP_CURVE_RIGHT",
  "WINDING_ROAD",
  "WINDING_ROAD_STARTING_LEFT",
  "WINDING_ROAD_STARTING_RIGHT",
  "STEEP_HILL_UPWARDS",
  "STEEP_HILL_DOWNWARDS",
  "STOP_SIGN",
  "LATERAL_WIND",
  "GENERAL_WARNING",
  "ANIMAL",
  "ICY_CONDITIONS",
  "SLIPPERY_ROAD",
  "UNEVEN_ROAD",
  "SCHOOL_ZONE",
  "CONGESTION_HAZARD",
  "ACCIDENT_HAZARD",
  "BICYCLE_CROSSING",
  "PRIORITY_OVER_ONCOMING_TRAFFIC",
  "YIELD",
  "PRIORITY_ROAD",
  "PRIORITY_ROAD_END",
  "TRAFFIC_CALMING",
  "TRAFFIC_CALMING_END",
  "ENVIRONMENTAL_AREA",
  "ENVIRONMENTAL_AREA_END",
  "INTERSECTION",
  "ROUNDABOUT",
  "PASSING_ON_LEFT",
  "PASSING_ON_RIGHT",
  "PASSING_ON_LEFT_OR_RIGHT",
  "MANDATORY_TURN_RIGHT_ONLY",
  "MANDATORY_TURN_LEFT_ONLY",
  "MANDATORY_STRAIGHT_ONLY",
  "MANDATORY_TURN_LEFT_OR_RIGHT",
  "MANDATORY_STRAIGHT_OR_LEFT",
  "MANDATORY_STRAIGHT_OR_RIGHT",
  "NO_LEFT_TURN",
  "NO_RIGHT_TURN",
  "NO_U_TURN",
  "U_TURN_ALLOWED",
  "NO_ENTRY",
  "DEAD_END",
  "HIGH_OCCUPANCY_VEHICLE_LANE",
  "TOLL",
  "SHOULDER_OPEN_FOR_TRAFFIC",
  "SHOULDER_CLOSED_FOR_TRAFFIC",
  "LANE_CLOSED",
  "LANE_CLOSED_RIGHT_MOST_LANE",
  "LANE_CLOSED_LEFT_MOST_LANE",
  "WARNING_PEDESTRIAN",
  "WARNING_CHILDREN",
  "WARNING_BUS",
  "PUBLIC_TRANSPORTATION_STOP",
  "PEDESTRIAN_CROSSING",
  "WEIGHT_RESTRICTION",
  "HEIGHT_RESTRICTION",
  "WIDTH_RESTRICTION",
  "WARNING_TRUCK_ROLLOVER",
  "SIGNAL_AHEAD",
  "NO_AGRICULTUR_VEHICLE",
  "NO_BICYCLE",
  "NO_BUS",
  "NO_HAUL_EXPLOSIVES",
  "NO_HAUL_HARMFUL_TO_WATER",
  "NO_HAUL_HAZARDOUS_MATERIAL",
  "NO_MOTORCYCLE",
  "ROAD_DISTANCE",
  "EMERGENCY_PHONE",
  "BOARD_DIRECTION",
  "TRUCK_SPEED_LIMIT",
  "TRUCK_SPEED_LIMIT_END",
  "SPEED_LIMIT_NIGHT",
  "SPEED_LIMIT_NIGHT_END",
  "MINIMUM_SPEED",
  "PEDESTRIAN_PATH",
  "PEDESTRIAN_BICYCLE_PATH",
  "BICYCLE_PATH",
  "BICYCLE_PATH_END",
  "BICYCLE_STREET",
  "BICYCLE_STREET_END",
  "CURVE_LEFT_THEN_RIGHT",
  "CURVE_RIGHT_THEN_LEFT",
  "NO_HORSE_RIDING",
  "FALLING_ROCKS",
  "YIELD_TO_ONCOMING_TRAFFIC",
  "ONEWAY_TRAFFIC",
  "ONEWAY_TRAFFIC_TO_LEFT",
  "ONEWAY_TRAFFIC_TO_RIGHT",
  "NO_VEHICLE",
  "NO_MOTOR_VEHICLE",
  "NO_PEDESTRIAN",
  "TIRE_CHAINS_MANDATORY",
  "TUNNEL",
  "NARROW_BRIDGE",
  "HUMPBACK_BRIDGE",
  "EMBANKMENT",
  "CROSSING_WITH_PRIORITY_OVER_MINOR_ROAD",
  "BRANCH_TO_THE_LEFT",
  "BRANCH_TO_THE_RIGHT",
  "TWO_WAY_TRAFFIC",
  "BUMP",
  "DIP",
  "MOVABLE_BRIDGE",
  "SLOW_DOWN",
  "INTERSECTION_T_LEFT",
  "INTERSECTION_T_RIGHT",
  "INTERSECTION_T_LEFT_RIGHT",
  "INTERSECTION_Y",
  "HONKING_PROHIBITED",
  "HIGHWAY_MARKER_1_STRIPE",
  "HIGHWAY_MARKER_2_STRIPES",
  "HIGHWAY_MARKER_3_STRIPES",
  "DIVERSION_ROUTE_END",
  "NO_STOPPING",
  "NO_STOPPING_LEFT_AND_RIGHT",
  "NO_PARKING",
  "NO_PARKING_LEFT_AND_RIGHT",
  "NO_TURN_ON_RED",
  "SPEED_LIMIT_ZONE",
  "SPEED_LIMIT_ZONE_END",
  "NO_PARKING_ZONE_END",
  "PARKING",
  "SAFETY_DISTANCE",
  "DETOUR",
  "MOTORWAY_EXIT",
  "HIGHWAY_EXIT",
  "LOW_FLYING",
  "LANE_SHIFT",
  "LANE_SHIFT_TO_LEFT",
  "LANE_SHIFT_TO_RIGHT",
  "BUS_LANE",
  "PEDESTRIAN_BICYCLE_SHARED_PATH",
  "OVERHEAD_LANE_CONTROL_CLOSING_LEFT",
  "TRINATURE",
  "GRAVEL",
  "WARNING_RIDER",
  "STOP_AHEAD",
  "YIELD_AHEAD",
  "NO_CAR_OR_BIKE",
  "ROUNDABOUT_AHEAD",
  "MANDATORY_LEFT_OR_STRAIGHT_OR_RIGHT",
  "AXLE_WEIGHT_RESTRICTION",
  "TOLL_END",
  "CHILDREN_END_TT",
  "FIRESTATION_TT",
  "NO_OUTLET_TT",
  "CANCELED_SIGN_TT",
  "EXIT_RIGHT_TT",
  "CAMERA_TT",
  "LANE_SPLIT_RIGHT_TT",
  "LOOSE_SHOULDER_TT",
  "BRIDGE_ICE_TT",
  "SCHOOL_ZONE_END_TT",
  "BUILT_UP_AREA_TT",
  "BUILT_UP_AREA_END_TT",
  "NO_PEDESTRIAN_CYCLING_TT",
  "ROAD_NUMBER_TT",
  "TUNNEL_EXIT_TT",
  "NO_TRACTOR_HORSE_TT",
  "TRAM_LANE_TT",
  "BUS_LANE_END_TT",
  "HIGH_BEAM_TT",
  "NO_HAUL_HAZARDOUS_MATERIAL_END_TT",
  "CONSTRUCTION_RIGHT_TT",
  "CONSTRUCTION_LEFT_TT",
  "LANES_TOPOLOGY_TT",
  "LANE_OPEN_TT",
  "EXIT_LEFT_TT",
  "FLAGGERS_AHEAD_TT",
  "PLAYGROUND_TT",
  "UNEVEN_LANES_TT",
  "SCHOOL_BUS_STOP_AHEAD_TT",
  "FLOOD_AREA_TT",
  "BE_PREPARED_TO_STOP_TT",
  "HIDDEN_DRIVEWAY_TT",
  "SPECIAL_NEEDS_CHILD_AREA_TT",
  "TRUCK_CROSSING_TT",
  "HAIRPIN_TURN_LEFT_TT",
  "HAIRPIN_TURN_RIGHT_TT",
  "LANE_SPLIT_LEFT_TT",
  "ENTRANCE_LEFT_TT",
  "ENTRANCE_RIGHT_TT",
  "RAILWAY_CROSSING_LEFT_TT",
  "RAILWAY_CROSSING_RIGHT_TT",
  "THRU_TRAFFIC_MERGE_LEFT_TT",
  "THRU_TRAFFIC_MERGE_RIGHT_TT",
  "SHARED_ROAD_PEDESTRIANS_BICYCLE_TT",
  "SHARED_ROAD_CARS_BICYCLE_TT",
  "DIVIDED_HIGHWAY_TT",
  "DIVIDED_HIGHWAY_END_TT",
  "AUTONOMOUS_VEHICLE_TT",
  "MULTI_SPEED_SIGN_TT",
  "TEXT_ONLY_TT",
  "ELECTRONIC_OFF_TT",
  "CONSTRUCTION_WITH_DIST_TT",
  "PEDESTRIAN_AND_BIKE_CROSSING_TT",
  "RAILWAY_CROSSING_1_TT",
  "RAILWAY_CROSSING_2_TT",
  "RAILWAY_CROSSING_3_TT",
  "WATER_COURSE_TT",
  "PARKING_BAY_TT",
  "NO_TURN_TT",
  "END_HIGH_FINE_ZONE_TT",
  "NO_LEFT_OR_RIGHT_TT",
  "NEW_LANE_RIGHT_TT",
  "NEW_LANE_LEFT_TT",
  "SHOULDER_MERGE_TT",
  "ADD_LEFT_TT",
  "ADD_RIGHT_TT",
  "ADD_FROM_LEFT_TT",
  "ADD_FROM_RIGHT_TT",
  "WRONG_WAY_TT",
  "NO_STRAIGHT_TT",
  "TRUCK_LANE_TT",
  "INTERCHANGE_TT",
  "OBSTRUCTION_ABOVE_TT",
  "BOARD_DIRECTION_ADVANCE_TT",
  "BOARD_DIRECTION_COMBINED_TT",
  "SHARED_ROAD_PEDESTRIANS_TT",
  "GATE_TT",
  "EMERGENCY_BAY_TT",
  "INTERSECTION_WITH_RAILWAY_TT",
  "LEFT_ABOVE_TFL_TT",
  "RIGHT_ABOVE_TFL_TT",
  "ALL_WAY_TT",
  "FOUR_WAY_TT",
  "SPLIT_RIGHT_TT",
  "SPLIT_LEFT_TT",
  "ROAD_H_TT",
  "DISABLED_TT",
  "SINGLE_WALKING_MAN_TT",
  "SINGLE_TT",
  "TRUCK_LIMIT_TT",
  "CITY_START_END_TT",
  "U_TURN_RIGHT_TT",
  "U_TURN_LEFT_TT",
  "ONEWAY_TRAFFIC_END_TT",
  "OBSTRUCTION_FISHBONE_LEFT_TT",
  "OBSTRUCTION_FISHBONE_RIGHT_TT",
  "OBSTRUCTION_LEFT_TT",
  "OBSTRUCTION_RIGHT_TT",
  "SHORT_POLE_TT",
  "BARREL_TT",
  "CONE_TT",
  "MANHOLE_TT",
  "LAMP_TT",
  "REFLECTOR_TT",
  "VEHICLE_LANE_TT",
  "SUPP_RECTANGULAR_EU_TT",
  "TRAFFIC_LIGHT_STRUCT_LEFT_TT",
  "TRAFFIC_LIGHT_STRUCT_RIGHT_TT",
  "TRAFFIC_LIGHT_STRUCT_BACK_TT",
  "GREEN_TFL_ARROW_TT",
  "PARKING_NOT_ALLOWED_TT",
  "PRIORITY_TURN_LEFT_TT",
  "GIVE_WAY_LEFT_TT",
  "PRIORITY_TURN_RIGHT_TT",
  "GIVE_WAY_RIGHT_TT",
  "ARROW_RECTANGULAR_TT",
  "CIRCULAR_UNKNOWN_TT",
  "BACK_OF_SIGN_TT",
  "NO_PARKING_START_TT",
  "NO_PARKING_END_TT",
  "NO_STOPPING_START_TT",
  "NO_STOPPING_END_TT",
  "STAGGERED_JUNCTION_LEFT_RIGHT_TT",
  "STAGGERED_JUNCTION_RIGHT_LEFT_TT",
  "MINOR_ROAD_CROSSING_PRIORITY_TT",
  "CURVE_LEFT_TT",
  "CURVE_RIGHT_TT",
  "DEVIATION_RIGHT_TT",
  "DEVIATION_LEFT_TT",
  "ROAD_DIAMOND_TT",
  "ROAD_X_TT",
  "ONEWAY_TRAFFIC_TOPOLOGY_TT",
  "TWO_WAY_TRAFFIC_TOPOLOGY_TT",
  "LANE_SPLIT_LEFT_TOPOLOGY_TT",
  "LANE_SPLIT_RIGHT_TOPOLOGY_TT",
  "LANE_MERGE_ON_LEFT_TOPOLOGY_TT",
  "LANE_MERGE_ON_RIGHT_TOPOLOGY_TT",
  "MERGE_TO_MAIN_FROM_LEFT_TT",
  "MERGE_TO_MAIN_FROM_RIGHT_TT",
  "AT_PEDESTRIAN_AND_BIKE_CROSSING_TT",
];
export var USED_SIGN_TYPES = [];
